import { render, staticRenderFns } from "./dialogRoleRenewal.vue?vue&type=template&id=5fac7ff2&scoped=true"
import script from "./dialogRoleRenewal.vue?vue&type=script&lang=js"
export * from "./dialogRoleRenewal.vue?vue&type=script&lang=js"
import style0 from "./dialogRoleRenewal.vue?vue&type=style&index=0&id=5fac7ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fac7ff2",
  null
  
)

export default component.exports